import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import { getQueryStringAsObject } from '../../../../utils/utils';
import * as api from '../../../../services/api';
import LoadingWidget from '../../../widgets/LoadingWidget/LoadingWidget';
import '../../../presenters/renewals/UnauthedRenewalPage/UnauthedRenewalPage.css';
import * as RenewalStatus from '../../../../constants/RenewalStatus';
import CustomerRenewalPage from '../../../presenters/renewals/UnauthedRenewalPage/UnauthedRenewalPage';
import { IMAGE_PREFIX } from '../../../../constants/constants';
import { RENEWAL_NOT_AVAILABLE_URL } from '../../../../route-names';

class UnauthedRenewalPageWrapper extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      renewal: null,
      customer: null,
      logo: null,
      renewalSignature: {
        signatureImage: null,
        fullName: null,
        email: null
      }
    };

    this.canBeSigned = this.canBeSigned.bind(this);
  }

  componentDidMount() {
    this.loadState();
  }

  pushError(queryParams, isError) {
    this.props.history.push({
      pathname: RENEWAL_NOT_AVAILABLE_URL,
      state: {
        queryParams: queryParams.key,
        isError: isError
      }
    });
  }

  async loadState() {
    const queryParams = getQueryStringAsObject();

    try {
      const renewalPromise = api.renewals.getBySecret(queryParams.key);
      const customerPromise = api.customers.getBySecret(queryParams.key);

      let responses = await Promise.all([renewalPromise, customerPromise]);

      if (!!responses[0].data && !!responses[1].data) {
        const renewal = {
          ...responses[0].data
        };

        const customer = {
          ...responses[1].data
        };

        const logoPromise = api.images.getLogo(customer.languageCode);
        const pdfPromise = api.renewals.getRenewalSummary(renewal.renewalId);

        responses = await Promise.all([logoPromise, pdfPromise]);

        this.setState({
          renewal,
          customer,
          renewalSignature: {
            signatureImage: renewal.customerSignatureImage || '',
            fullName: renewal.customerApproverName || '',
            email: renewal.customerEmail || ''
          },
          logo: IMAGE_PREFIX + responses[0].data.value,
          pdfData: responses[1].data,
          loading: false
        });
      } else {
        this.pushError(queryParams, false);
      }
    } catch (e) {
      this.pushError(queryParams, true);
    }
  }

  canBeSigned() {
    return !(
      this.state.renewal.status === RenewalStatus.COMPLETED.name ||
      this.state.renewal.status === RenewalStatus.APPROVAL_REQUIRED.name
    );
  }

  render() {
    return this.state.loading ? (
      <LoadingWidget />
    ) : (
      <CustomerRenewalPage
        customer={this.state.customer}
        renewal={this.state.renewal}
        pdfData={this.state.pdfData}
        renewalSignature={this.state.renewalSignature}
        enabled={this.canBeSigned()}
        invalidFields={this.state.invalidFields}
        logo={this.state.logo}
      />
    );
  }
}

export default withRouter(UnauthedRenewalPageWrapper);
